import { DateTime } from 'luxon';
import { DATE_TIME_FORMAT } from '@constants/date-time.constants';
import { IRedemption } from '@interfaces/redemption';
import { ITransactions } from '@interfaces/transaction';

export const groupRedemptionsByDate = (transactions: IRedemption[] = []) => {
	const result: {
		[key: string]: ITransactions<IRedemption>;
	} = {};
	transactions.forEach((txn) => {
		const date = DateTime.fromJSDate(new Date(txn.redeemDate) as Date).toFormat(DATE_TIME_FORMAT);
		if (result[date]) {
			result[date].transactions.push(txn);
		} else {
			result[date] = {
				transactions: [txn],
				createdAt: date,
			};
		}
	});
	const transactionsGroup = Object.values(result);
	return { transactionsGroup };
};

export const ungroupRedemptionsByDate = (transactionsGroup: ITransactions<IRedemption>[]) => {
	const redemptions: IRedemption[] = [];
	transactionsGroup.forEach((group) => {
		group.transactions.forEach((txn) => {
			redemptions.push(txn);
		});
	});
	return redemptions;
};

export const markNewRedemptionAsOld = (redemptions: IRedemption[], existingRedemptions: IRedemption[]) => {
	return redemptions.map((redemption) => {
		if (redemption.isNew) {
			for (const existingRedemption of existingRedemptions) {
				if (existingRedemption.redemptionId === redemption.redemptionId && !existingRedemption.isNew) {
					redemption.isNew = false;
					break;
				}
			}
		}
		return redemption;
	});
};
